import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgKeuken = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FF7842"
      d="M34 16H6v18h28z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M17 8.5a2.5 2.5 0 0 0-2.5 2.5h-1a3.5 3.5 0 1 1 7 0v5h-1v-5A2.5 2.5 0 0 0 17 8.5"
      clipRule="evenodd"
    />
    <path
      fill="#FFBFA5"
      d="M18 18H8v14h10zM32 18H22v14h10z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M30.25 30.25V28h1v3.25h-8v-1z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="M14 19.5h2.75v1H14zM23.25 19.5H26v1h-2.75z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M16.84 15.25h6.41v1h-6.41z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgKeuken);

export default ForwardRef;
